export default __webpack_public_path__ + "static/media/nft3.d983b554.png";